module.exports = __webpack_public_path__ + "img/footer-wb.fafac873.png";